<ng-container *ngFor="let banner of banners; trackBy: 'id' | trackByProperty">
    <div *ngIf="!viewState.dismissed.has(banner.id)" class="alert" [ngClass]="[getBannerClass(banner.status)]">
        <span class="alert-message" [innerHTML]="banner.message"></span>
        <button *ngIf="banner.dismissible" class="alert-close" (click)="close(banner.id)">
            <pureui-svg class="pstg-action-icon" svg="close.svg" height="9" />
        </button>
    </div>
</ng-container>
